import { SVGProps } from 'react'

export const WpsLinkSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M12.898 9.897a4.798 4.798 0 01-6.786 0l-.003-.003-1.25-1.267s.458-.529 1.11-.661a1.851 1.851 0 011.18.17l.379.348a2.798 2.798 0 003.955-.001l1.636-1.636A2.798 2.798 0 109.162 2.89l-.839.839a4.816 4.816 0 00-2.537-.273l.317-.335 1.645-1.645a4.798 4.798 0 116.785 6.785l-1.635 1.636zM3.1 6.05a4.798 4.798 0 016.786 0l.003.003 1.25 1.267s-.458.53-1.109.661c-.651.133-1.182-.17-1.182-.17l-.378-.348a2.798 2.798 0 00-3.955.002L2.879 9.1a2.798 2.798 0 003.957 3.957l1.203-1.203a4.82 4.82 0 002.758.004l.008.008-.91.96-1.645 1.645a4.798 4.798 0 01-6.785-6.785L3.1 6.05z'
      fill='#0A6CFF'
      fillRule='evenodd'
    />
  </svg>
)
